import React, { useState, useEffect, useRef, useMemo } from 'react';
import { FileText, Pencil, Globe, Eye, X, Loader, Upload, Printer } from 'lucide-react';
import apiService from '../config';
import html2pdf from 'html2pdf.js';
import { useLanguage } from '../StoreContext/LanguageContext';
import { useSignature } from '../DigitalSignature/UseSignatue';
import SignaturePad from '../DigitalSignature/SignaturePad';

export const CoveringLetters = ({ modalParams = {}, onBack, onUpdated, moduleType, setSelectedComponent }) => {
    const {
      uploadStatus,
      uploadError,
      selectedSignDocument,
      resetSignatureState,
      setUploadStatus,
      setUploadError,
      signDocument
    } = useSignature();

    
    const [showSignaturePad, setShowSignaturePad] = useState(false);
    const [pdfForSigning, setPdfForSigning] = useState(null);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [viewerFile, setViewerFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    

    console.log('CoveringLetters component rendered with:', {
        modalParams,
        moduleType,
        onBack: typeof onBack,
        setSelectedComponent: typeof setSelectedComponent
    });
    const [activeModule, setActiveModule] = useState(moduleType || "laoAssign");
    const [projectId, setProjectId] = useState(null);
    const [projectName, setProjectName] = useState(null);
    const [proposalId, setProposalId] = useState(null);
    const notificationContentRef = useRef(null);
    const { language, translations } = useLanguage();

    // Proposal
    const [proposalData, setProposalData] = useState({});
    const [ProposalLoading, setProposalLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        // Editable fields
        project_id: '',
        proposal_id: '',
        covering_letter_name: '',
        office_name: '',
        branch_name: '',
        address: '',
        email: '',
        contact_no: '',
        notification_no: '',
        date: '',
        subject: '',
        reference: '',
        default_content1: '',
        default_content2: '',

    });
    console.log("Proposal", proposalData);


    // Define which fields are editable
    const editableFields = [
        'project_id',
        'proposal_id',
        'covering_letter_name',
        'office_name',
        'branch_name',
        'address',
        'email',
        'contact_no',
        'notification_no',
        'date',
        'subject',
        'reference',
        'default_content1',
        'default_content2',
    ];

    // Covering Letter
    const [coveringLetterData, setCoveringLetterData] = useState({});
    const [coveringLetterDefaultData, setCoveringLetterDefaultData] = useState({});
    const [laoUserData, setUserLaoData] = useState({});
    const [projectInchageUserData, setProjectInchageUserData] = useState({});

    // total owner and holder aquire area
    const [ownerAquireTotal, setOwnerAquireTotal] = useState(0);
    const [holderAquireTotal, setHolderAquireTotal] = useState(0);
    const [loadingRecords, setLoadingRecords] = useState(false);

    // Objections
    const [objection, setObjections] = useState([]);

    // LAO Name and Designation
    const [allLaoUsers, setAllLaoUsers] = useState([]);
    const [usersLAO, setusersLAO] = useState([]);
    const laoName = usersLAO?.[0]?.full_name || 'N/A';
    const laoDesi = usersLAO?.[0]?.designation || 'N/A';
    console.log('User Name:', laoName);
    console.log('User Designation:', laoDesi);

    // Collector Users
    const [usersCollector, setUsersCollector] = useState([]);

    // Landowner aquire area total
    const [landHolderAquireAreaTotal, setLandHolderAquireAreaTotal] = useState([]);

    // LAO Update
    const [isLaoEditing, setIsLaoEditing] = useState(false);
    const [selectedOfficerId, setSelectedOfficerId] = useState(usersLAO[0]?.user_id || "");
    const [isSaving, setIsSaving] = useState(false);

    // Roles
    const ROLES = {
        COLLECTOR: 1,
        LAO: 3,
        SAMANVAY: 6,
        DATA_ENTRY: 14,
    };
    const userData = JSON.parse(localStorage.getItem('userData'));
    const userRole = parseInt(userData?.data?.user_role || userData.user_role, 10);

    // Project Id
    useEffect(() => {
        const getProjectInfo = () => {
            const currentProjectData = localStorage.getItem('currentProjectData');
            if (currentProjectData) {
                try {
                    const projectData = JSON.parse(currentProjectData);
                    return {
                        id: projectData.project_id || projectData.id,
                        name: projectData.project_name || projectData.name
                    };
                } catch (e) {
                    console.error('Error parsing current project data (currentProjectData):', e);
                }
            }

            const selectedProject = localStorage.getItem('selectedProject');
            if (selectedProject) {
                try {
                    const project = JSON.parse(selectedProject);
                    return {
                        id: project.project_id || project.id,
                        name: project.project_name || project.name
                    };
                } catch (e) {
                    console.error('Error parsing selected project (selectedProject):', e);
                }
            }

            const userData = localStorage.getItem('userData');
            if (userData) {
                try {
                    const user = JSON.parse(userData);
                    const projectId = user.data?.project_id || user.project_id;
                    const projectName = user.data?.project_name || user.project_name || 'Unknown Project';
                    return {
                        id: projectId,
                        name: projectName
                    };
                } catch (e) {
                    console.error('Error parsing user data (userData):', e);
                }
            }
            return { id: null, name: null };
        };

        const projectInfo = getProjectInfo();
        setProjectId(projectInfo.id);
        setProjectName(projectInfo.name);
        console.log('Current Project Info:', projectInfo);
    }, []);

    // Proposal id
    useEffect(() => {
        const getProposalInfo = () => {
            const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');

            if (currentProposal) {
                try {
                    return {
                        proposalId: currentProposal?.data?.default_proposal ||
                            currentProposal?.data?.proposal_id ||
                            currentProposal?.default_proposal ||
                            currentProposal?.proposal_id ||
                            null
                    }
                } catch (e) {
                    console.error('Error parsing current project data (getProposalInfo):', e);
                }
            }
            return { proposalId: null };
        };

        const proposalInfo = getProposalInfo();
        setProposalId(proposalInfo.proposalId);
        console.log('Current Project-Proposal Info:', proposalInfo);
    }, []);

    useEffect(() => {
        if (projectId && proposalId) {
            fetchProposalData();
            fetchCoveringLetterData();
            fetchDefaultCoveringLetterData();
            fetchusersLAO();
            fetchOwnerData();
            fetchObjections();
            fetchLandOwnersAquireAreaTotal();
            fetchUserCollector();
        }
    }, [projectId, proposalId]);

     useEffect(() => {
      if (!selectedSignDocument) return;
    
      const postSignedPdf = async () => {
        try {
          const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
          const projectId = selectedProject?.id || selectedProject?.project_id;
          const proposalId = localStorage.getItem("currentProposalId");
    
          if (!projectId || !proposalId) {
            console.error("Missing projectId or proposalId");
            return;
          }
    
          await apiService.postAddSignaturePDF(
            projectId,
            proposalId,
            "CoveringLettersSection11",      // 🔁 change per section
            selectedSignDocument   // ✅ signed PDF only
          );
    
          const sectionRes = await apiService.getSectionFile(
            projectId,
            proposalId,
            "CoveringLettersSection11"
          );
    
          if (sectionRes?.isSignAvailable && sectionRes.data?.[0]?.file_path) {
            setPreviewUrl(sectionRes.data[0].file_path);
          }
    
        } catch (error) {
          console.error("Error posting signed PDF:", error);
        }
      };
    
      postSignedPdf();
    }, [selectedSignDocument]);

    useEffect(() => {
        fetchUsersAllLAO();
    }, []);

    useEffect(() => {
        if (modalParams.userId && proposalData.cre_usr_id) {
            fetchUserData();
        }
    }, [modalParams.userId, proposalData.cre_usr_id]);

    // Proposal
    const fetchProposalData = async () => {
        setProposalLoading(true);
        try {
            const response = await apiService.getProposalPublish(projectId, proposalId);
            if (response.status === 200 && response.data) {
                const data = response.data;
                setProposalData(data);
                // setFormData(data);
            } else {
                console.log('No proposal data found');
            }

        } catch (err) {
            console.error('Error fetching proposal data:', err);
            alert('Failed to fetch proposal data');
        } finally {
            setProposalLoading(false);
        }
    };

    // Covering Letter
    const fetchCoveringLetterData = async () => {
        setProposalLoading(true);
        try {

            let type =
                activeModule === "laoAssign" ? "LaoAssign" :
                    activeModule === "section11" ? "Section-11" :
                        activeModule === "section19" ? "Section-19" :
                            activeModule === "section15" ? "Section-15" : "";

            const response = await apiService.getCoveringLetter(projectId, proposalId, type);

            if (response.status === 200 && response.data) {
                const data = response.data[0];
                setCoveringLetterData(data);
                setFormData(data);
            } else {
                console.log('No proposal data found');
            }

        } catch (err) {
            console.error('Error fetching proposal data:', err);
            alert('Failed to fetch proposal data');
        } finally {
            setProposalLoading(false);
        }
    };

    const fetchDefaultCoveringLetterData = async () => {
        setProposalLoading(true);
        try {

            let type = "LaoAssign";
            const response = await apiService.getCoveringLetter(projectId, proposalId, type);

            if (response.status === 200 && response.data) {
                const data = response.data[0];
                setCoveringLetterDefaultData(data);
            } else {
                console.log('No proposal data found');
            }

        } catch (err) {
            console.error('Error fetching proposal data:', err);
            alert('Failed to fetch proposal data');
        } finally {
            setProposalLoading(false);
        }
    };

    // User Name
    const fetchUserData = async () => {
        if (!modalParams.userId || !proposalData.cre_usr_id) return;

        setProposalLoading(true);
        try {
            // Fetch both users in parallel for better performance
            const [laoResponse, projectInchargeResponse] = await Promise.all([
                apiService.getAllUserById(modalParams.userId), // Selected User Id
                apiService.getAllUserById(proposalData.cre_usr_id) // Project Incharge
            ]);

            // Handle LAO user data
            if (laoResponse.status === 200 && laoResponse.data) {
                setUserLaoData(laoResponse.data);
            } else {
                console.log('No LAO user data found');
            }

            // Handle Project Incharge user data
            if (projectInchargeResponse.status === 200 && projectInchargeResponse.data) {
                setProjectInchageUserData(projectInchargeResponse.data);
            } else {
                console.log('No project incharge data found');
            }

        } catch (err) {
            console.error('Error fetching user data:', err);
            alert('Failed to fetch user data');
        } finally {
            setProposalLoading(false);
        }
    };

    const fetchUsersAllLAO = async () => {
        try {
            const response = await apiService.getAllUserRoleLAO();
            if (response.status === 200 && response.data) {
                const users = Array.isArray(response.data) ? response.data : [];
                setAllLaoUsers(users);
            }
        } catch (error) {
            console.error('Error fetching LAO users:', error);
            setAllLaoUsers([]);
        } finally {
        }
    };

    // fetch LAO users
    const fetchusersLAO = async () => {
        const role = 3;
        // setLoadingusersLAO(true);
        try {
            const response = await apiService.getAssignLAO(role, projectId, proposalId);
            console.log('LAO users:', response);
            if (response.status === 200 && response.data) {
                setusersLAO(Array.isArray(response.data) ? response.data : []);
            } else {
                setusersLAO([]);
            }
        } catch (error) {
            console.error('Error fetching LAO users:', error);
            setusersLAO([]);
        } finally {
            // setLoadingusersLAO(false);
        }
    };

    // fetch Collector users
    const fetchUserCollector = async () => {
        const role = 1;
        // setLoadingusersLAO(true);
        try {
            const response = await apiService.getAllUserCollector(role);
            console.log('Collecor users:', response);
            if (response.status === 200 && response.data) {
                setUsersCollector(Array.isArray(response.data) ? response.data : []);
            } else {
                setUsersCollector([]);
            }
        } catch (error) {
            console.error('Error fetching LAO users:', error);
            setUsersCollector([]);
        } finally {
            // setLoadingusersLAO(false);
        }
    };

    // total of areas
    const fetchOwnerData = async () => {
        // Validate IDs
        if (!projectId || !proposalId || projectId <= 0 || proposalId <= 0) {
            console.log('Invalid project or proposal ID:', { projectId, proposalId });
            return;
        }

        try {
            setLoadingRecords(true);
            console.log("Fetching owner/holder total acquired areas...");

            const result = await apiService.get("getAllOwner", {
                projectId,
                proposalId,
                isActive: 1
            });

            if (result.status === 200 && Array.isArray(result.landAcquisition)) {

                // Calculate Owner total acquired area
                const ownerAquireTotal = result.landAcquisition.reduce((ownerSum, item) => {
                    if (Array.isArray(item.owners) && item.owners.length > 0) {
                        const itemOwnerTotal = item.owners.reduce(
                            (sum, owner) => sum + parseFloat(owner.owner_aqr_area || 0),
                            0
                        );
                        return ownerSum + itemOwnerTotal;
                    }
                    return ownerSum;
                }, 0);

                // Calculate Holder total acquired area
                const holderAquireTotal = result.landAcquisition.reduce((holderSum, item) => {
                    return holderSum + parseFloat(item.total_area || 0);
                }, 0);

                // Fix to 4 decimal places properly
                const fixedOwnerTotal = Math.round(ownerAquireTotal * 10000) / 10000;
                const fixedHolderTotal = Math.round(holderAquireTotal * 10000) / 10000;

                console.log("Owner Total Acquired Area:", fixedOwnerTotal);
                console.log("Holder Total Acquired Area:", fixedHolderTotal);

                // Save totals in state if needed
                setOwnerAquireTotal(fixedOwnerTotal);
                setHolderAquireTotal(fixedHolderTotal);
            }

            fetchProposalData();
        } catch (error) {
            console.error('Error fetching totals:', error);
        } finally {
            setLoadingRecords(false);
        }
    };

    // Objections total
    const fetchObjections = async () => {

        try {
            const response = await apiService.getAllGeneralObjections(projectId, proposalId);
            setObjections(Array.isArray(response) ? response : []);
        } catch (error) {
            console.error('Error fetching LAO users:', error);
            setObjections([]);
        } finally {
            // setLoadingusersLAO(false);
        }
    };

    // LandHolders Aquire area total for LAO Assign
    const fetchLandOwnersAquireAreaTotal = async () => {
        if (!projectId || !proposalId) return;

        setLoadingRecords(true);
        try {
            const locationParams = { proposalId: proposalId };
            const result = await apiService.getLandHolding(projectId, locationParams);

            if (result.status === 200 && Array.isArray(result.data)) {
                let totalAquireArea = 0;

                result.data.forEach(item => {
                    if (Array.isArray(item.owners)) {
                        item.owners.forEach(owner => {
                            totalAquireArea += parseFloat(owner.owner_aqr_area || 0);
                        });
                    }
                });

                setLandHolderAquireAreaTotal(totalAquireArea.toFixed(4));
            } else {
                setLandHolderAquireAreaTotal(0);
            }
        } catch (error) {
            console.error('Error fetching all land holdings:', error);
            setLandHolderAquireAreaTotal([]);
        } finally {
            setLoadingRecords(false);
        }
    };

    // handleEdit
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!projectId || !proposalId) {
            alert('❌ No projectId and proposal ID found for update.');
            return;
        }
        try {
            setLoading(true);
            const invalidValues = ["", "N/A", "null", "undefined"];

            let type =
                activeModule === "laoAssign" ? "LaoAssign" :
                    activeModule === "section11" ? "Section-11" :
                        activeModule === "section19" ? "Section-19" :
                            activeModule === "section15" ? "Section-15" : "";

            // const updateProposalData = {
            //     section_23_date: formData.section_23_date || new Date(),
            //     section_23_office_name: formData.section_23_office_name || proposalData.section_19_office_name || '',
            //     section_23_branch_name: formData.section_23_branch_name || proposalData.section_19_branch_name || '',
            //     section_23_notification_no: formData.section_23_notification_no || proposalData.section_19_notification_no || '',
            //     section_23_nature_of_land: formData.section_23_nature_of_land || '',
            //     administrative_order_no: formData.administrative_order_no || '',
            //     administrative_order_date: formData.administrative_order_date || '',

            //     section_23_no1_content:
            //         formData.section_23_no1_content &&
            //             !invalidValues.includes(formData.section_23_no1_content.trim()) &&
            //             formData.section_23_no1_content.trim() !==
            //             (defaultContents["no_1"] || "").trim()
            //             ? formData.section_23_no1_content.trim()
            //             : defaultContents["no_1"],

            // };

            const updateCoveingLetterData = {
                project_id: projectId,
                proposal_id: proposalId,
                covering_letter_name: type,
                office_name: formData.office_name || coveringLetterDefaultData.office_name || '',
                branch_name: formData.branch_name || coveringLetterDefaultData.branch_name || '',
                address: formData.address || coveringLetterDefaultData.address || '',
                email: formData.email || coveringLetterDefaultData.email || '',
                contact_no: formData.contact_no || coveringLetterDefaultData.contact_no || '',
                notification_no: formData.notification_no || proposalData.section_11_notification || '',
                date: formData.date || new Date() || '',
                // subject: formData.subject || '',
                reference: formData.reference || '',

                default_content1:
                    formData.default_content1 &&
                        !invalidValues.includes(formData.default_content1.trim()) &&
                        formData.default_content1.trim() !==
                        (defaultContents["no_1"] || "").trim()
                        ? formData.default_content1.trim()
                        : defaultContents["no_1"],

                default_content2:
                    formData.default_content2 &&
                        !invalidValues.includes(formData.default_content2.trim()) &&
                        formData.default_content2.trim() !==
                        (defaultContents["no_2"] || "").trim()
                        ? formData.default_content2.trim()
                        : defaultContents["no_2"],

            };

            if (formData.subject) {
                updateCoveingLetterData.subject = formData.subject;
            }

            // const proposalResult = await apiService.updateProposal(
            //     proposalId,
            //     updateProposalData
            // );

            const coveringResult = await apiService.postCoveringLetter(
                updateCoveingLetterData
            );

            if (coveringResult.status === 200) {
                // if (proposalResult.status === 200 && coveringResult.status === 200 ) {
                alert('Updated successfully!');
                setIsEditing(false);
                if (onUpdated) onUpdated();
                fetchProposalData();
                fetchCoveringLetterData();
            } else {
                alert('❌ Failed to update proposal.');
            }
        } catch (err) {
            console.error('Error updating proposal:', err);
            alert('❌ Error while updating proposal.');
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // Only allow changes to editable fields
        if (editableFields.includes(name)) {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));

            // If user is editing section_19_content, mark it as edited
            // if (name === 'section_19_content') {
            //   setHasUserEditedSection1(true);
            // }
            // if (name === 'section_19_tip') {
            //   setHasUserEditedTip(true);
            // }
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const formatDateForInput = (dateString) => {
        // If no date provided, use today
        if (!dateString) {
            const today = new Date();
            return today.toISOString().split('T')[0]; // yyyy-mm-dd
        }

        const date = new Date(dateString);

        // Check if date is invalid OR default 1900 date
        if (isNaN(date) || date.getFullYear() === 1900) {
            const today = new Date();
            return today.toISOString().split('T')[0];
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    //  LAO Update
    const handleAssignLAO = async (laoUserId) => {
        const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
        const projectId = selectedProject?.id || selectedProject?.project_id;

        if (!laoUserId || !projectId || !proposalId) {
            alert('Missing Information', 'All fields are required to assign LAO Officer.');
            return;
        }

        const payload = {
            usr_id: laoUserId,
            usr_role: 3,
            project_id: projectId,
            acquisition_proposal_id: proposalId,
            is_active: 1
        };

        try {
            setIsSaving(true); // 👈 show loader

            const response = await apiService.addAssignRole(payload);

            console.log("✅ LAO Assigned Successfully:", response);
            await fetchusersLAO();

        } catch (error) {
            console.error("❌ Failed to assign LAO:", error);
        } finally {
            setIsSaving(false); // 👈 hide loader
        }
    };

    const renderLAOAssign = () => {
        return (
            <div>
                <div>
                    <p className="text-center underline font-bold text-l">आदेश</p>
                    <div className="m-2">
                    <p className="flex">
                    <span className="font-bold whitespace-nowrap">विषय:&nbsp;</span>
                    <span>{coveringLetterData.subject}</span>
                    </p>
                    <div className="flex">
                    <div className="font-bold whitespace-nowrap">
                        संदर्भ:
                    </div>

                    <div className="ml-2">
                        {coveringLetterData.reference
                        ?.split(/\n|\d+\)/)
                        ?.filter(Boolean)
                        ?.map((item, index) => (
                            <div key={index} className="flex">
                            <div className="w-6">{index + 1})</div>
                            <div>{item.trim()}</div>
                            </div>
                        ))}
                    </div>
                    </div>                    
                    </div>
                </div>

                <div className="mt-2 text-justify">
                    <p className="indent-8">
                        {renderTextWithFormatting(getContent("default_content1", "no_1", "display"))}
                    </p>
                    <div className="overflow-x-auto p-2">
                        <table className="table-auto border border-gray-700 w-full text-sm">
                            <tbody>
                                <tr>
                                    <td className="border border-gray-700 p-2">1</td>
                                    <td className="border border-gray-700 p-2">प्रकल्प नाव</td>
                                    <td className="border border-gray-700 p-2">{projectName}</td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-700 p-2">2</td>
                                    <td className="border border-gray-700 p-2">प्रस्तावाचे नाव</td>
                                    <td className="border border-gray-700 p-2">{proposalData.acquisition_proposal_no || ''}</td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-700 p-2">3</td>
                                    <td className="border border-gray-700 p-2">गाव, तालुका आणि जिल्हा</td>
                                    <td className="border border-gray-700 p-2">गाव:{proposalData.village_name || ''}, तालुका:{proposalData.taluka_name || ''}, जिल्हा:{proposalData.dist_name || ''}</td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-700 p-2">4</td>
                                    <td className="border border-gray-700 p-2">भूसंपादन प्रकरणात समाविष्ट संपादीत क्षेत्र</td>
                                    <td className="border border-gray-700 p-2">{landHolderAquireAreaTotal}</td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-700 p-2">5</td>
                                    <td className="border border-gray-700 p-2">भूसंपादनाचे प्रयोजन</td>
                                    <td className="border border-gray-700 p-2">{proposalData.acquisition_purpose || ''}</td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-700 p-2">6</td>
                                    <td className="border border-gray-700 p-2">यंत्रणेचे नांव</td>
                                    <td className="border border-gray-700 p-2">{proposalData.acquisition_incharge_designation || ''}</td>
                                </tr>
                                {/* LAO Update */}
                                <tr>
                                    <td className="border border-gray-700 p-2 text-center">7</td>
                                    <td className="border border-gray-700 p-2">भूसंपादकरीता प्राधिकृत अधिकारी</td>

                                    <td className="border border-gray-700 p-2">
                                        {isLaoEditing ? (
                                            <div className="flex items-center space-x-2">
                                                <select
                                                    className="border border-gray-400 rounded-md p-1 flex-1"
                                                    value={selectedOfficerId}
                                                    onChange={(e) => setSelectedOfficerId(e.target.value)}
                                                >
                                                    <option value="">अधिकारी निवडा</option>

                                                    {allLaoUsers.map((user) => {
                                                        const isAssigned =
                                                            usersLAO.length > 0 &&
                                                            usersLAO[0].usr_id === user.usr_id;
                                                        return (
                                                            <option key={user.user_id} value={user.usr_id}>
                                                                {user.full_name} {user.designation} {isAssigned ? "(Assigned)" : ""}
                                                            </option>
                                                        );
                                                    })}
                                                </select>

                                                <button
                                                    onClick={async () => {
                                                        if (!selectedOfficerId) {
                                                            alert("कृपया अधिकारी निवडा");
                                                            return;
                                                        }
                                                        await handleAssignLAO(selectedOfficerId);
                                                        setIsLaoEditing(false);
                                                    }}
                                                    disabled={isSaving}
                                                    className={`px-3 py-1 rounded text-white ${isSaving ? "bg-green-400 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"
                                                        }`}
                                                >
                                                    {isSaving ? (
                                                        <div className="flex items-center space-x-2">
                                                            <Loader className="animate-spin" size={16} />
                                                            <span>Saving...</span>
                                                        </div>
                                                    ) : (
                                                        "Save"
                                                    )}
                                                </button>

                                                <button
                                                    onClick={() => setIsLaoEditing(false)}
                                                    className="bg-gray-400 hover:bg-gray-500 text-white px-3 py-1 rounded"
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="flex items-center justify-between">
                                                <span>
                                                    {usersLAO.length > 0 ? (
                                                        <>
                                                            {usersLAO[0].full_name}
                                                        </>
                                                    ) : (
                                                        "—"
                                                    )}
                                                </span>

                                                <button
                                                    onClick={() => setIsLaoEditing(true)}
                                                    className="ml-2 text-blue-600 hover:text-blue-800 text-sm font-medium no-print"
                                                >
                                                    <Pencil size={18} />
                                                </button>
                                            </div>
                                        )}
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p className="indent-8">
                        {getContent("default_content2", "no_2", "display")}
                    </p>
                    <div>
                        <b>सहपत्र :-</b> मुळ प्रस्ताव 2 प्रतीत
                    </div>
                    <div className="flex flex-col items-end mt-10 collector-signature">
                        <p>({usersCollector?.[0]?.full_name || 'N/A'})</p>
                        <p>{usersCollector?.[0]?.designation || 'N/A'}</p>
                    </div>
                    <div className="mt-4">
                    <div className="flex">
                        <div className="font-bold whitespace-nowrap">प्रत:</div>
                        <div className="ml-2">
                        <div>1) {laoDesi} यांना माहिती तथा उचित कार्यवाहीस्तव अग्रेषीत.</div>
                        <div>2) {proposalData.acquisition_incharge_designation} यांना माहिती तथा उचित कार्यवाहोस्तव अग्रेषीत.</div>
                        </div>
                    </div>
                    </div>

                </div>

            </div>
        );
    };

    const renderSection11 = () => {
        return (
            <div>
                <div>
                    <p className="text-center underline font-bold">आदेश</p>
                    <div className="m-8">
                        <p><b>विषय :-</b> {coveringLetterData.subject}</p>
                        <p><b>संदर्भ :-</b> {coveringLetterData.reference}</p>
                    </div>
                </div>

                <div className="mt-8 text-justify">
                    <p className="indent-8">
                        {renderTextWithFormatting(getContent("default_content1", "no_1", "display"))}
                    </p>

                    <div>
                        <b>सहपत्र :-</b> मुळ प्रस्ताव 2 प्रतीत
                    </div>
                    <div className="flex flex-col items-end mt-44">
                        <p>({usersCollector?.[0]?.full_name || 'N/A'})</p>
                        <p>{usersCollector?.[0]?.designation || 'N/A'}</p>
                    </div>
                    <div className="mt-8">
                        <p className="font-bold">प्रत:-</p>
                        <p className="ml-6">1) {laoDesi} यांना माहिती तथा उचित कार्यवाहीस्तव अग्रेषीत.</p>
                        <p className="ml-16">/- उपरोक्त कलम 11 (1) ची प्रत सर्व संबंधीतांना उलट टपाली पाठवून त्यांचे स्तरावरील जबाबदारी व त्या अनुषंगाने विहीत कालावधीत करावयाच्या सर्वकार्यवाही बाबत संबंधीतांना अवगत करावे.</p>
                        <p className="ml-6">2) {proposalData.acquisition_incharge_designation} यांना माहिती तथा उचित कार्यवाहोस्तव अग्रेषीत.</p>
                        <p className="ml-16">/- उपरोक्त प्रकरणांत निधी प्राप्त करणेबाबत दायीत्व सर्वस्वी आपली आहे याची नोंद घेवुन नियमान्वये उचित कार्यवाही करावी.</p>
                    </div>

                </div>

            </div>
        );
    };

    const renderSection19 = () => {
        return (
            <div>
                <div>
                    <p className="text-center underline font-bold">आदेश</p>
                    <div className="m-8">
                        <p><b>विषय :-</b> भूमिसंपादन, पुनर्वसन व पुनर्वसाहत करताना उचित भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम-2013 च्या कलम 19 (1) खालील घोषणेस मान्यता प्रदान करणेबाबत.</p>
                        <p><b>भूसंपादन प्रकरण क्रमांक :-</b> {proposalData.section_11_bhusampadan_no}</p>
                        <p><b>संदर्भ :-</b> {coveringLetterData.reference}</p>
                    </div>
                </div>

                <div className="mt-8 text-justify">
                    <p className="indent-8">
                        {renderTextWithFormatting(getContent("default_content1", "no_1", "display"))}
                    </p>

                    <div className="flex justify-end mt-44">
                        <p>जिल्हाधिकारी बुलढाणा</p>
                    </div>
                    <div className="mt-8">
                        <p className="font-bold">प्रत:-</p>
                        <p className="ml-6">{projectInchageUserData.full_name} यांना माहिती तथा उचित कार्यवाहोस्तव अग्रेषीत.</p>
                    </div>

                </div>

            </div>
        );
    };

    const renderSection15 = () => {
        return (
            <div>
                <div className="mt-8">
                    <p className="text-left font-bold">प्रति,</p>
                    <p className="text-left font-bold">{laoName}</p>
                    <div className="m-8">
                        <p><b>विषय :-</b>भूमिसंपादन, पुनर्वसन व पुनर्वसाहत करताना उचित भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम-2013 च्या कलम 15 (2) अंतर्गत मान्यता प्रदान करणेबाबत.</p>
                        <p className="text-center"><b>भूसंपादन प्रकरण क्रमांक :-</b> {proposalData.section_11_bhusampadan_no}</p>
                        <p><b>संदर्भ :-</b> {coveringLetterData.reference}</p>
                    </div>
                </div>

                <div className="mt-8 text-justify">
                    <p className="indent-8">
                        {renderTextWithFormatting(getContent("default_content1", "no_1", "display"))}
                    </p>

                    <div className="flex justify-end mt-44">
                        <p>जिल्हाधिकारी बुलढाणा</p>
                    </div>
                    <div className="mt-8">
                        <p className="font-bold">प्रत:-</p>
                        <p className="ml-6">{projectInchageUserData.full_name} यांना माहिती तथा उचित कार्यवाहोस्तव अग्रेषीत.</p>
                    </div>

                </div>

            </div>
        );
    };

    const renderAll = () => {
        try {
            switch (activeModule) { // add parentheses and use activeModule
                case 'laoAssign':
                    return renderLAOAssign();
                case 'section11':
                    return renderSection11();
                case 'section19':
                    return renderSection19();
                case 'section15':
                    return renderSection15();
                default:
                    return renderLAOAssign(); // Default fallback
            }
        } catch (error) {
            console.error('Error in renderAll:', error);
            return <div>Error loading content</div>;
        }
    };

    const SignatureLoader = ({ text }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div className="bg-white rounded-lg p-6 flex flex-col items-center space-y-4">
      <div className="animate-spin rounded-full h-10 w-10 border-4 border-blue-600 border-t-transparent"></div>
      <p className="text-sm font-medium text-gray-700">{text}</p>
    </div>
  </div>
);

    const renderNotificationDocument = (ref) => (
        <div
            ref={ref} id="notification-content"
            className="space-y-4 m-1 p-1 bg-white shadow-lg rounded-lg border border-gray-300"
            style={{
                minHeight: '4500mm',
                width: '210mm',
                padding: '15mm',
                margin: '0 auto'
            }}>

            {/* Header */}
            <div className="text-center mb-5">
                {/* Logo */}
                <img
                    src="/Emblem_of_India.svg"
                    alt="महाराष्ट्र शासन"
                    className="mx-auto mb-1 w-20"
                />

                {/* Government name */}
                <div className="font-bold text-[15px]">महाराष्ट्र शासन</div>
                <div className="font-bold text-[15px]">महसूल व वन विभाग</div>

                {/* Office Name */}
                <div className="font-bold text-xl font-semibold">
                    {/* {getFieldValue('section_19_office_name', 'section_11_office_name', '')} */}
                    {coveringLetterData.office_name || coveringLetterDefaultData.office_name || ''}
                </div>

                {/* Branch */}
                <div className="font-medium text-[15px] font-semibold">
                    शाखा :- {coveringLetterData.branch_name || coveringLetterDefaultData.branch_name || ''}
                </div>

                {/* Address */}
                <div className="text-[15px] font-semibold">
                    {coveringLetterData.address || coveringLetterDefaultData.address || ''}
                </div>

                {/* Bottom Contact Section */}
                <div className="text-xs mt-2">
                    {/* First row: Email + Kramank */}
                    <div className="flex justify-between">
                        <div>
                            ई-मेल :- <span className="font-bold text-black-700">{coveringLetterData.email || coveringLetterDefaultData.email || ''}</span>
                        </div>
                        <div>
                            दूरध्वनी क्रमांक :- {coveringLetterData.contact_no || coveringLetterDefaultData.contact_no || ''}
                            {/* क्रमांक :- {getFieldValue('kramank_no', '')} */}
                        </div>
                    </div>

                    {/* Horizontal line */}
                    <hr className="border-black border-2 my-1" />

                    {/* Second row: Reference no + Date */}
                    <div className="flex justify-between">
                        <div>
                            {coveringLetterData.notification_no || coveringLetterDefaultData.notification_no || ''}
                        </div>
                        <div>
                            दिनांक :- {formatDate(coveringLetterData.date || new Date() || '')}
                        </div>
                    </div>
                </div>
            </div>

            {renderAll()}

        </div>
    );

    const renderEditLaoAssign = () => (
        <div>
            <div>
                {/* Two-column grid */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            कार्यविवरण क्रमांक :
                        </label>
                        <input
                            type="text"
                            name="notification_no"
                            value={formData.notification_no}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            p placeholder="Enter Notification no..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            दिनांक :
                        </label>
                        <input
                            type="date"
                            name="date"
                            value={formatDateForInput(formData.date)}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Date..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            दूरध्वनी क्रमांक :
                        </label>
                        <input
                            type="text"
                            name="contact_no"
                            value={formData.contact_no}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Mobile No..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            कार्यालयाचे नाव :
                        </label>
                        <input
                            type="text"
                            name="office_name"
                            value={formData.office_name}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Office name..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            शाखेचे नाव :
                        </label>
                        <input
                            type="text"
                            name="branch_name"
                            value={formData.branch_name}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Branch name..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            ई-मेल :
                        </label>
                        <input
                            type="text"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Email..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            कार्यालयाचा पत्ता व पिनकोड :
                        </label>
                        <input
                            type="text"
                            name="address"
                            value={formData.address}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Address..."
                        />
                    </div>

                </div>

                <div className="space-y-6 pt-4">
                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            विषय :
                        </label>
                        <input
                            type="text"
                            name="subject"
                            value={formData.subject}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter subject..."
                        />
                    </div>
                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            संदर्भ :
                        </label>
                        <input
                            type="text"
                            name="reference"
                            value={formData.reference}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter reference..."
                        />
                    </div>
                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            प्रस्तावना:
                        </label>
                        <textarea
                            name="default_content1"
                            value={getContent("default_content1", "no_1", "edit")}
                            onChange={handleInputChange}
                            rows={15}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                            placeholder="Enter section content..."
                        />
                        <p className="text-sm text-gray-500 mt-1">
                            {formData.default_content1 &&
                                formData.default_content1.trim() !== '' &&
                                formData.default_content1 !== 'N/A' &&
                                formData.default_content1 !== 'null' &&
                                formData.default_content1 !== 'undefined' &&
                                formData.default_content1.trim() !== (defaultContents["no_1"] || "").trim()
                                ? "Using custom content."
                                : "Default content is shown. Start typing to use custom content."}
                        </p>
                    </div>
                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            प्रस्तावना:
                        </label>
                        <textarea
                            name="default_content1"
                            value={getContent("default_content2", "no_2", "edit")}
                            onChange={handleInputChange}
                            rows={4}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                            placeholder="Enter section content..."
                        />
                        <p className="text-sm text-gray-500 mt-1">
                            {formData.default_content2 &&
                                formData.default_content2.trim() !== '' &&
                                formData.default_content2 !== 'N/A' &&
                                formData.default_content2 !== 'null' &&
                                formData.default_content2 !== 'undefined' &&
                                formData.default_content2.trim() !== (defaultContents["no_2"] || "").trim()
                                ? "Using custom content."
                                : "Default content is shown. Start typing to use custom content."}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );

    const renderEditSection11 = () => (
        <div>
            <div>
                {/* Two-column grid */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            कार्यविवरण क्रमांक :
                        </label>
                        <input
                            type="text"
                            name="notification_no"
                            value={formData.notification_no || proposalData.section_11_notification}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            p placeholder="Enter Notification no..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            दिनांक :
                        </label>
                        <input
                            type="date"
                            name="date"
                            value={formatDateForInput(formData.date)}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Date..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            दूरध्वनी क्रमांक :
                        </label>
                        <input
                            type="text"
                            name="contact_no"
                            value={formData.contact_no || coveringLetterDefaultData.contact_no}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Mobile No..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            कार्यालयाचे नाव :
                        </label>
                        <input
                            type="text"
                            name="office_name"
                            value={formData.office_name || coveringLetterDefaultData.office_name}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Office name..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            शाखेचे नाव :
                        </label>
                        <input
                            type="text"
                            name="branch_name"
                            value={formData.branch_name || coveringLetterDefaultData.branch_name}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Branch name..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            ई-मेल :
                        </label>
                        <input
                            type="text"
                            name="email"
                            value={formData.email || coveringLetterDefaultData.email}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Email..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            कार्यालयाचा पत्ता व पिनकोड :
                        </label>
                        <input
                            type="text"
                            name="address"
                            value={formData.address || coveringLetterDefaultData.address}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Address..."
                        />
                    </div>

                </div>

                <div className="space-y-6 pt-4">
                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            विषय :
                        </label>
                        <input
                            type="text"
                            name="subject"
                            value={formData.subject}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter subject..."
                        />
                    </div>
                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            संदर्भ :
                        </label>
                        <input
                            type="text"
                            name="reference"
                            value={formData.reference}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter reference..."
                        />
                    </div>
                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            प्रस्तावना:
                        </label>
                        <textarea
                            name="default_content1"
                            value={getContent("default_content1", "no_1", "edit")}
                            onChange={handleInputChange}
                            rows={18}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                            placeholder="Enter section content..."
                        />
                        <p className="text-sm text-gray-500 mt-1">
                            {formData.default_content1 &&
                                formData.default_content1.trim() !== '' &&
                                formData.default_content1 !== 'N/A' &&
                                formData.default_content1 !== 'null' &&
                                formData.default_content1 !== 'undefined' &&
                                formData.default_content1.trim() !== (defaultContents["no_1"] || "").trim()
                                ? "Using custom content."
                                : "Default content is shown. Start typing to use custom content."}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );

    const renderEditSection19 = () => (
        <div>
            <div>
                {/* Two-column grid */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            कार्यविवरण क्रमांक :
                        </label>
                        <input
                            type="text"
                            name="notification_no"
                            value={formData.notification_no || proposalData.section_11_notification}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            p placeholder="Enter Notification no..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            दिनांक :
                        </label>
                        <input
                            type="date"
                            name="date"
                            value={formatDateForInput(formData.date)}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Date..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            दूरध्वनी क्रमांक :
                        </label>
                        <input
                            type="text"
                            name="contact_no"
                            value={formData.contact_no || coveringLetterDefaultData.contact_no}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Mobile No..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            कार्यालयाचे नाव :
                        </label>
                        <input
                            type="text"
                            name="office_name"
                            value={formData.office_name || coveringLetterDefaultData.office_name}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Office name..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            शाखेचे नाव :
                        </label>
                        <input
                            type="text"
                            name="branch_name"
                            value={formData.branch_name || coveringLetterDefaultData.branch_name}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Branch name..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            ई-मेल :
                        </label>
                        <input
                            type="text"
                            name="email"
                            value={formData.email || coveringLetterDefaultData.email}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Email..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            कार्यालयाचा पत्ता व पिनकोड :
                        </label>
                        <input
                            type="text"
                            name="address"
                            value={formData.address || coveringLetterDefaultData.address}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Address..."
                        />
                    </div>

                </div>

                <div className="space-y-6 pt-4">
                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            विषय :
                        </label>
                        <input
                            type="text"
                            name="subject"
                            value={formData.subject}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter subject..."
                        />
                    </div>
                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            संदर्भ :
                        </label>
                        <input
                            type="text"
                            name="reference"
                            value={formData.reference}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter reference..."
                        />
                    </div>
                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            प्रस्तावना:
                        </label>
                        <textarea
                            name="default_content1"
                            value={getContent("default_content1", "no_1", "edit")}
                            onChange={handleInputChange}
                            rows={14}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                            placeholder="Enter section content..."
                        />
                        <p className="text-sm text-gray-500 mt-1">
                            {formData.default_content1 &&
                                formData.default_content1.trim() !== '' &&
                                formData.default_content1 !== 'N/A' &&
                                formData.default_content1 !== 'null' &&
                                formData.default_content1 !== 'undefined' &&
                                formData.default_content1.trim() !== (defaultContents["no_1"] || "").trim()
                                ? "Using custom content."
                                : "Default content is shown. Start typing to use custom content."}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );

    const renderEditSection15 = () => (
        <div>
            <div>
                {/* Two-column grid */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            कार्यविवरण क्रमांक :
                        </label>
                        <input
                            type="text"
                            name="notification_no"
                            value={formData.notification_no || proposalData.section_11_notification}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            p placeholder="Enter Notification no..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            दिनांक :
                        </label>
                        <input
                            type="date"
                            name="date"
                            value={formatDateForInput(formData.date)}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Date..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            दूरध्वनी क्रमांक :
                        </label>
                        <input
                            type="text"
                            name="contact_no"
                            value={formData.contact_no || coveringLetterDefaultData.contact_no}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Mobile No..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            कार्यालयाचे नाव :
                        </label>
                        <input
                            type="text"
                            name="office_name"
                            value={formData.office_name || coveringLetterDefaultData.office_name}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Office name..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            शाखेचे नाव :
                        </label>
                        <input
                            type="text"
                            name="branch_name"
                            value={formData.branch_name || coveringLetterDefaultData.branch_name}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Branch name..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            ई-मेल :
                        </label>
                        <input
                            type="text"
                            name="email"
                            value={formData.email || coveringLetterDefaultData.email}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Email..."
                        />
                    </div>

                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            कार्यालयाचा पत्ता व पिनकोड :
                        </label>
                        <input
                            type="text"
                            name="address"
                            value={formData.address || coveringLetterDefaultData.address}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter Address..."
                        />
                    </div>

                </div>

                <div className="space-y-6 pt-4">
                    {/* <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            विषय :
                        </label>
                        <input
                            type="text"
                            name="subject"
                            value={formData.subject}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter subject..."
                        />
                    </div> */}
                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            संदर्भ :
                        </label>
                        <input
                            type="text"
                            name="reference"
                            value={formData.reference}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                            placeholder="Enter reference..."
                        />
                    </div>
                    <div className="group">
                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                            प्रस्तावना:
                        </label>
                        <textarea
                            name="default_content1"
                            value={getContent("default_content1", "no_1", "edit")}
                            onChange={handleInputChange}
                            rows={14}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                            placeholder="Enter section content..."
                        />
                        <p className="text-sm text-gray-500 mt-1">
                            {formData.default_content1 &&
                                formData.default_content1.trim() !== '' &&
                                formData.default_content1 !== 'N/A' &&
                                formData.default_content1 !== 'null' &&
                                formData.default_content1 !== 'undefined' &&
                                formData.default_content1.trim() !== (defaultContents["no_1"] || "").trim()
                                ? "Using custom content."
                                : "Default content is shown. Start typing to use custom content."}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );

    const renderEditContent = () => {
        switch (activeModule) {
            case 'laoAssign':
                return renderEditLaoAssign();
            case 'section11':
                return renderEditSection11();
            case 'section19':
                return renderEditSection19();
            case 'section15':
                return renderEditSection15();
            default:
                return renderEditLaoAssign(); // Default fallback
        }
    };

    const renderEditModal = () => (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                <div className="p-8">
                    <div className="flex justify-between items-center mb-6">
                        <h2 className="text-2xl font-bold text-gray-800">
                            {activeModule === 'laoAssign' && translations[language].Edit}
                            {activeModule === 'section11' && translations[language].CoveringLettersSection11 + " " + translations[language].Edit}
                            {activeModule === 'section19' && translations[language].CoveringLettersSection19 + " " + translations[language].Edit}
                            {activeModule === 'section15' && translations[language].CoveringLettersSection15 + " " + translations[language].Edit}
                        </h2>
                        <button
                            onClick={() => setIsEditing(false)}
                            className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
                        >
                            ×
                        </button>
                    </div>

                    <form onSubmit={handleSubmit}>

                        {renderEditContent()}

                        {/* Action Buttons */}
                        <div className="flex flex-col sm:flex-row justify-end space-y-3 sm:space-y-0 sm:space-x-4 pt-3 border-t border-gray-200">
                            <button
                                type="button"
                                onClick={() => setIsEditing(false)}
                                className="px-6 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 transform hover:scale-105"
                            >
                                {translations[language].Cancel}
                            </button>
                            <button
                                type="submit"
                                disabled={loading}
                                className="px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed transform hover:scale-105 flex items-center justify-center space-x-3 shadow-lg"
                            >
                                {loading && (
                                    <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                                )}
                                <span>{loading ? translations[language]?.Saving : translations[language]?.CommonSave}</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div >
        </div >
    );

    const handleUploadedFile = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  resetSignatureState();     // 🔥 important
  setPdfForSigning(file);
  setShowSignaturePad(true);
};

const handleViewSignedPdf = async () => {
  try {
    const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
    const projectId = selectedProject?.id || selectedProject?.project_id;
    const proposalId = localStorage.getItem("currentProposalId");

    if (!projectId || !proposalId) {
      alert("Project or Proposal not found");
      return;
    }

    const res = await apiService.getSectionFile(
      projectId,
      proposalId,
      "CoveringLettersSection11" // 🔁 change per section
    );

    if (res?.isSignAvailable && res?.data?.[0]?.file_path) {
      setViewerFile(res.data[0].file_path);
      setIsViewerOpen(true);     // modal
      // OR 👉 window.open(res.data[0].file_path, "_blank");
    } else {
      alert("Signed document not available");
    }
  } catch (error) {
    console.error("Error viewing signed PDF:", error);
    alert("Unable to open signed document");
  }
};

    const handlePrintView = () => {
        // Create a new window with print-optimized content
        const printWindow = window.open('', '_blank');

        if (!printWindow) {
            alert('Please allow popups to use the print feature.');
            return;
        }

        // Get the content
        const content = notificationContentRef.current.innerHTML;

        // Dowload name
        let letterTitle = "Covering Letter";
        if (activeModule === 'laoAssign') {
            letterTitle = translations[language].CoveringLetters;
        } else if (activeModule === 'section11') {
            letterTitle = translations[language].CoveringLettersSection11;
        } else if (activeModule === 'section19') {
            letterTitle = translations[language].CoveringLettersSection19;
        } else if (activeModule === 'section15') {
            letterTitle = translations[language].CoveringLettersSection15;
        }

        // Create HTML for print window
        const printHTML = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>${letterTitle}</title>
      <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;600;700&display=swap" rel="stylesheet">
      <style>
        @page {
          size: A4 portrait;   /* Orientation */
          margin-top: 0.19in;
          margin-bottom: 0.25in;
          margin-left: 0.81in;
          margin-right: 0.5in;
        }
        
        * {
          box-sizing: border-box;
        }
        
        body {
          font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
          font-size: 12px;
          line-height: 1.4;
          color: black;
          background: white;
          margin: 0;
          padding: 0;
        }
        
        .print-container {
          width: 100%;
          max-width: none;
          background: white;
        }
        
        .pr-3{
          padding-right:1rem;
        }
        
        table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 1rem;
          page-break-inside: auto !important;
        }
  
        thead {
            display: table-header-group;
        }

        tr {
            page-break-inside: avoid;
            page-break-after: auto;
        }

        td, th {
            border: 1px solid black;
            padding: 8px;
            font-size: 11px;
            page-break-inside: avoid;
        }
        
        h1, h2, h3, h4, h5, h6 {
          margin: 1rem 0 0.5rem 0;
          page-break-after: avoid;
          font-weight: bold;
        }
        
        p {
          margin: 0.5rem 0;
          text-align: justify;
          line-height: 1.5;
          orphans: 3;
          widows: 3;
        }

        .text-2xl { font-size: 1.8rem; }
        .flex { display: flex; }
        .justify-between { justify-content: space-between; }
        .justify-end { justify-content: flex-end; }
        .items-end { align-items: flex-end; }
        .text-center { text-align: center; }
        .mt-44 { margin-top: 2rem; float:right }
        .m-10{ margin: 5rem; }
        .m-8{ margin: 2rem; }
        .text-right { text-align: right; }
        .ml-auto{ margin-left: auto; }
        .font-bold { font-weight: bold; }
        .underline { text-decoration: underline; }
        .indent-8 { text-indent: 2rem; }
        .mt-8 { margin-top: 2rem; }
        .mb-2 { margin-bottom: 0.5rem; }
        .mb-6 { margin-bottom: 1.5rem; }
        .flex { display: flex; }
        .justify-center{ justify-content: center; }
        .ml-6 { margin-left: 20px; }
        .ml-16 { margin-left: 40px; }
        .flex { display: flex;}
        .flex-col {flex-direction: column;}
        .items-end { align-items: flex-end;}
        .text-sm { font-size: 0.875rem; }

        .w-auto{
          width:auto;
          max-width: 28rem;
        }

        .space-y-4 > * + * {
          margin-top: 1rem;
        }
        
        .mx-auto{
          margin-left: auto;
          margin-right: auto;
          width : 8%;
          margin-bottom:2px;
        }

        .border-black{
          border : 1.5px solid black;
        }

        .underline {
          text-decoration: underline;
        }

       @media print {
  body {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  /* Hide elements you don’t want to print */
  .no-print {
    display: none !important;
  }

  /* Keep web flex layouts */
  .flex {
    display: flex !important;
  }

  .flex-col {
    flex-direction: column !important;
  }

  .items-end {
    align-items: flex-end !important;
  }

  .justify-between {
    justify-content: space-between !important;
  }

  .justify-center {
    justify-content: center !important;
  }

  .mt-44 {
    margin-top: 2rem !important;
    float: none !important; /* remove float for print */
  }

  .ml-auto {
    margin-left: auto !important;
  }

  .ml-6 {
    margin-left: 1.5rem !important;
  }

  .ml-16 {
    margin-left: 4rem !important;
  }

  .m-8 {
    margin: 2rem !important;
  }

  .m-10 {
    margin: 5rem !important;
  }

  /* Remove top margin of signature container */
  .collector-signature {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  /* Remove default paragraph spacing */
  .collector-signature p {
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1.2 !important;
  }

  table {
    border-collapse: collapse !important;
    width: 100% !important;
  }

  td, th {
    border: 1px solid black !important;
    padding: 8px !important;
  }

  .underline {
    text-decoration: underline !important;
  }

  .font-bold {
    font-weight: bold !important;
  }

  .indent-8 {
    text-indent: 2rem !important;
  }

  .text-center {
    text-align: center !important;
  }

  .text-right {
    text-align: right !important;
  }

  .text-2xl {
    font-size: 1.8rem !important;
  }

  .space-y-4 > * + * {
    margin-top: 1rem !important;
  }
}

      </style>
    </head>
    <body>
      <div class="print-container">
        ${content}
      </div>
      <script>
        window.onload = function() {
          window.focus();
          window.print();
        };
      </script>
    </body>
    </html>
  `;

        printWindow.document.write(printHTML);
        printWindow.document.close();
    };

    const renderTextWithFormatting = (text) => {
        if (!text) return null;

        return text.split("\n").map((line, index) => (
            <p
                key={index}
                style={{
                    textAlign: "justify",
                    marginBottom: "0.5rem",
                    textIndent:"2rem",
                    whiteSpace: "pre-line" // preserves line breaks
                }}
            >
                {line.replace(/\t/g, "\u00A0\u00A0\u00A0")} {/* replace tabs with 3 spaces */}
            </p>
        ));
    };

    // All Default Contents
    const ALL_DEFAULT_CONTENTS = {
        laoAssign: {
            no_1: `संदर्भीय पत्रानुसार ${projectInchageUserData.full_name || ''} यांचे संदर्भीय पत्रानुसार ${projectName} साठी ${proposalData.acquisition_proposal_no} करीता मौजे ${proposalData.village_name} ता. ${proposalData.taluka_name} जि. ${proposalData.dist_name} येथील खाजगी जमिनीचा भूसंपादन प्रस्ताव या कार्यालयास प्राप्त झाला आहे.
            
            अर्थी भूमी संपादन पुनर्वसन व पुर्नस्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम 2013 चे कलम 3(e)(v) च्या परंतुकान्वये जिल्हाधिकारी ठराविक मर्यादितील क्षेत्रासाठी संबधित जिल्हयातील भूसंपादन करावायाच्या क्षेत्रासाठी समुचोत शासन आहे. 
            
            महाराष्ट्र शासन राजपत्र भाग चार-अ असाधारण क्र. 38 दि. 13/03/2015 मध्ये नमूद केलेले आहे की, उक्त अधिनियमान्वये कलम 10-क समाविष्ठ केले असुन त्यामध्ये अशी तरतुद केली आहे की, समुचीत शासनाला जनहिताचे दृष्टीने अधिसूचनेव्दारे उक्त अधिनियमाच्या प्रकरण दोन व प्रकरण तीन च्या तरतुदी लागु करण्यापासुन पुढील प्रकल्पापैकी कोणत्याही प्रकल्पाला सुट देता येईल त्यामधील प्रकल्पाचे यादी (ख) नुसार विदयुतीकरण, सिंचन, रस्ते, पाणी पुरवठा, व जलसंधारण यासह ग्रामीण भागातील पायाभूत सुविधा यांना सुट देण्यात आली आहे.  
            
            त्याअर्थी, मी जिल्हाधिकारी बुलढाणा समुचीत शासन म्हणून मला प्रदान केलेल्या शक्तीनुसार खालील नमुद विवरणातील स्तंभ 07 मधील अधिकारी यांना भूसंपादना करीता प्राधिकृत करीत आहे.`,

            no_2: `प्राधिकृत अधिकारी यांनी भूसंपादनाची कार्यवाही भूसंपादन पुनर्वसन व पुर्नस्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम 2013 चे अधिन राहुन व वेळोवेळी शासनाने काढलेल्या शासन निर्णय परीपत्रके व पत्रान्वये विहीत कालावधीत पुर्ण करावी तसेच सदर प्रस्तावात काही त्रुटी असतील तर त्यांची पुर्तता यंत्रणा अधिकारी यांच्या कडुन करुन घ्यावी. निधी प्राप्त करणे ही जबाबदारी भूसंपादन व यंत्रणा अधिकारी यांची राहील.`
        },
        section11: {
            no_1: `संदर्भीय पत्रानुसार ${laoDesi} यांनी भूसंपादन प्रकरण क्रमांक ${proposalData.section_11_bhusampadan_no || ''} प्रकरणात भूमिसंपादन, पुनर्वसन व पुनर्वसाहत करताना उचित भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम-2013 चे कलम 11(1) ची प्रारंभिक अधिसुचना मंजुरीस्तव प्रस्ताव या कार्यालयास प्राप्त झाला आहे. कलम 11(1) करीता प्रस्तावित एकुण क्षेत्र ${landHolderAquireAreaTotal} हे. आर आहे.
            
            सदर भूसंपादन प्रकरण ${laoDesi} यांचेकडे या कार्यालयाचे आदेश क्रमांक ${coveringLetterDefaultData.notification_no} दि. ${formatDate(coveringLetterDefaultData.date)} अन्वये चालविण्यसाठी देण्यात आले होते. 
            
            संपादन करावयाच्या खाजगी जमिनीचा भूसंपादन करण्यासाठीचा प्राप्त प्रस्तावात भूसंपादनाची कार्यवाही भूमिसंपादन, पुनर्वसन व पुनर्वसाहत करताना उचित भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम-2013 अन्वये कलम 11(1) च्या अधिसुचनेस खालील अटीचे अधिन राहुन मान्यता प्रदान करण्यात येत आहे.
                        
            1) विषयांकीत अधिनियम 2013 चे कलम 12 ते 19 चे तंतोतंत पालन करावे

            2) सदर प्राथमिक अधिसुचना कलम 11 च्या प्रसिध्दीच्या दिनांका पासुन 12 महिन्यांचे आत उक्त अधिनियमाचे कलम 11 ते 19 पावेतो सर्व पोट कलमांचे पालन करून कलम 19 करणे बंधनकारक आहे. त्यानुसार सर्व संबंधीतांनी (आदेश प्रति व प्रतिलीपी ज्यांना आहे त्या सर्वानी) नोंद घेऊन आपण आपल्या स्तरावरील कार्यवाही विहीत कालावधीत पूर्ण होईल याची कटाक्षाने दक्षता घेऊन योग्य नियोजन करावे. प्रकरणात सर्व विहीत प्रक्रिया पुर्ण न झाल्याचे कारणाने प्रकरण रदद होणर नाही याची दक्षता सर्व संबंधीतांनी घ्यावी. प्रकरण व्यपंगत / रदद झाल्यास संबंधीतावर प्रशासकीय कार्यवाही निश्चीत करण्यात येईल याची नोंद घ्यावी.`
        },
        section19: {
            no_1: `संदर्भीय पत्रानुसार ${laoName} यांनी भूसंपादन प्रकरण क्रमांक ${proposalData.section_11_bhusampadan_no} मध्ये संपादीत होणा-या जमिनीच्या भूमिसंपादन, पुनर्वसन व पुनर्वसाहत करताना उचित भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम-2013 चे कलम 19 (1) च्या घोषणेस मान्यता प्रदान करणेबाबत प्रस्ताव या कार्यालयात प्राप्त झाला आहे. (क्षेत्र 114.77 हे. आर. संयुक्त मोजणी नुसार)

उक्त भूसंपादन प्रकरणात कलम 11(1) ची प्रारंभिक अधिसुचना आवश्यक असलेल्या संबधित सर्व ठिकाणी प्रसिध्दी करण्यात आल्यानंतर विहीत मुदतीत प्राप्त आक्षेप निर्गत करण्यात आल्याने. 15(2) खालील तरतुदीचा अहवाल निरंक असल्यामुळे जिल्हाधिकारी बुलढाणा यांचे आदेश क्रमांक ____ अन्वये सदर प्रकरणात कलम 15(3) ची मान्यता देण्यात आलेली आहे.

सदर प्रकरणात कलम 11(1) ची प्रारंभिक अधिसुचने नुसार क्षेत्र ${holderAquireTotal} हे. आर होते संयुक्त मोजणी अहवालानुसार एकुण संपादनाखालील एकूण क्षेत्र ${ownerAquireTotal} हे. आर निश्चित करण्यात आल्यामुळे कलम 19(1) ची घोषणेखालील क्षेत्र ${ownerAquireTotal} असल्याबाबत ${laoName} यांनी संदर्भीय पत्रानुसार कळविले आहे. त्यामुळे कलम 19(1) घोषणेचे क्षेत्र ${ownerAquireTotal} कायम ठेवण्यात आले आहे.

सबब सदर प्रकरणात भूमिसंपादन, पुनर्वसन व पुनर्वसाहत करताना उचित भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम-2013 चे कलम 19(1) च्या घोषणेस मान्यता`
        },
        section15: {
            no_1: `संदर्भीय पत्राव्दारे आपण भूसंपादन प्रकरण क्रमांक ${proposalData.section_11_bhusampadan_no} मध्ये भूमिसंपादन, पुनर्वसन व पुनर्वसाहत करताना उचित भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम-2013 चे कलम 15(2) अंतर्गत मान्यता प्रदान करण्याबाबत प्रस्ताव या कार्यालयास संदर्भीय पत्रान्वये सादर केला आहे.

सदर प्रकरणात या कार्यालयाचे आदेश क्रर्माक _____ अन्वये एकुण ${holderAquireTotal} क्षेत्रास कलम 11(1) प्रारंभीक अधिसुचनेस मान्यता प्रदान करण्यात आली असुन कलम 11(1) प्रारंभीक अधिसुचना आवश्यक असलेल्या संबधित सर्व ठिकाणी प्रसिध्दी करण्यात आल्यानंतर विहीत मुदतीत (60 दिवसाच्या कालावधी मध्ये) एकुण ${objection.length} भूधारकांचे आक्षेप/हरकत प्राप्त झालेले असता तो आक्षेप/हरकत निकाली काढण्यात आलेल आहे. त्यामुळे भूमिसंपादन, पुनर्वसन व पुनर्वसाहत करताना उचित भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम-2013 चे कलम 15(2) खालील तरतुदीचा अहवाल निरंक असल्याबाबत आपण संदर्भीय पत्रानुसार कळविले आहे. त्यानुसार एकुण ${holderAquireTotal} हे.आर. क्षेत्र कायम ठेवण्यात आले आहे.

त्यानुसार उक्त प्रकरणात भूमिसंपादन, पुनर्वसन व पुनर्वसाहत करताना उचित भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम-2013 चे कलम 15(3) चे अधिन राहून मान्यता प्रदान करण्यात येत आहे.`,
        }
    };

    const defaultContents = ALL_DEFAULT_CONTENTS[activeModule] || ALL_DEFAULT_CONTENTS.laoAssign;

    // 2. Generic Helper Function
    const getContent = (fieldName, key, mode = "display") => {
        const userContent = formData[fieldName];
        const defaultContent = defaultContents[key] || "";
        const invalidValues = ["", "N/A", "null", "undefined"];

        if (typeof userContent === "string") {
            const trimmed = userContent.trim();

            if (mode === "edit") {
                // Edit mode → always show formData if valid
                return !invalidValues.includes(trimmed)
                    ? userContent.replace(/\\n/g, "\n")
                    : defaultContent;
            } else {
                // Display mode → show formData only if valid AND not same as default
                return !invalidValues.includes(trimmed) && trimmed !== defaultContent.trim()
                    ? userContent.replace(/\\n/g, "\n")
                    : defaultContent;
            }
        }

        // Fallback → if userContent is not a string
        return defaultContent;
    };

    if (ProposalLoading) {
        return (
            <div className="p-6 max-w-7xl mx-auto">
                <div className="flex justify-center items-center h-80">
                    <div className="text-center animate-float">
                        <div className="inline-flex relative">
                            <div className="w-16 h-16 rounded-full border-4 border-slate-700 border-t-transparent animate-spin"></div>
                            <div className="w-16 h-16 rounded-full border-4 border-purple-500 border-b-transparent border-r-transparent animate-spin absolute inset-0" style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}></div>
                            <div className="absolute inset-0 flex items-center justify-center">
                                <FileText className="h-6 w-6 text-purple-400 animate-pulse" />
                            </div>
                        </div>
                        <p className="text-gray-400 mt-4">मान्यता लोड होते आहे...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="bg-gray-50 min-h-screen">
                <div className="max-w-7xl mx-auto p-4">
                    {/* Header */}
                    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                        <div className=" justify-between items-center">
                            <div>
                                {/* <h1 className="text-2xl font-bold text-gray-900">प्रारुप निवाडा (कलम-23)</h1> */}
                                <p className="mt-1">
                                    {/* Project ID: {projectId} | Proposal ID: {proposalId || 'Not Found'} */}
                                    {/* {modalParams.selectedUser}<br /> */}
                                    {/* {modalParams.userId} */}
                                </p>
                            </div>

                            {/* Action Buttons */}
                            <div className="flex gap-3">
                                {/* <button
                                    onClick={onBack}   
                                    className="px-6 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 transition-colors flex items-center space-x-2"
                                >
                                    Compeleted
                                </button> */}

                                 {/* {userRole === ROLES.COLLECTOR && (
                                    <>  
                                <button className="relative">
                                <label className="flex items-center space-x-2 px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 cursor-pointer">
                                <Upload size={18} />
                                <span>Upload Signature</span>
                                <input
                                    type="file"
                                    accept="application/pdf,image/*"
                                    className="hidden"
                                    onChange={handleUploadedFile}
                                />
                                </label>
                                </button>

                                <button
                                    onClick={handleViewSignedPdf}
                                    className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700"
                                >
                                    <Printer size={18} />
                                    <span>View Signed PDF</span>
                                </button>
                                </> 
                                 )} */}

                                <button
                                    type="button"
                                    onClick={handlePrintView}
                                    className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center space-x-2"
                                >
                                    {translations[language]?.Print}
                                </button>

                                {(userRole === ROLES.SAMANVAY || userRole === ROLES.DATA_ENTRY)  && (
                                    <button
                                        type="button"
                                        onClick={() => setIsEditing(true)}
                                        className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2"
                                    >
                                        {translations[language]?.Edit}
                                    </button>
                                )}

                            </div>
                        </div>
                    </div>

                    {/* Main Document Display */}
                    <div>
                        {renderNotificationDocument(notificationContentRef)}
                    </div>

                    {/* Edit Modal */}
                    {isEditing && renderEditModal()}

                </div>

                {showSignaturePad && pdfForSigning && (
                  <SignaturePad
                    pdfFile={pdfForSigning}
                    onSign={(signaturesArray) => {
                      setShowSignaturePad(false);
                
                      // ✅ ONLY sign here
                      signDocument(pdfForSigning, signaturesArray);
                
                      setPdfForSigning(null);
                    }}
                    onCancel={() => {
                      setShowSignaturePad(false);
                      setPdfForSigning(null);
                    }}
                  />
                )}
                
                {isViewerOpen && viewerFile && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
                    <div className="bg-white rounded-lg w-[80%] max-w-6xl h-[80%] relative">
                
                      <div className="flex justify-between items-center px-4 py-2 border-b">
                        <h3 className="text-lg font-semibold">Signed Document</h3>
                        <button
                          onClick={() => setIsViewerOpen(false)}
                          className="text-xl font-bold"
                        >
                          ✕
                        </button>
                      </div>
                
                      <iframe
                        src={viewerFile}
                        title="Signed PDF Viewer"
                        className="w-full h-full"
                      />
                    </div>
                  </div>
                )}
                
                {(uploadStatus === "signing" || uploadStatus === "uploading") && (
                  <SignatureLoader
                    text={
                      uploadStatus === "signing"
                        ? "Applying digital signature…"
                        : "Uploading signed document…"
                    }
                  />
                )}

            </div>

        </>
    );
};

export default CoveringLetters;  